<template>
  <div class="login">
    <div class="f-w mt-20">欢迎登录</div>
    <van-cell-group class="mt-20">
      <van-field v-model="form.mobile" maxlength='11' type='tel' value="" placeholder="请输入手机号" :left-icon="img.mobile">
        <van-button @click="getCode" slot="button" round  size="small" color="#F6AB00" :disabled="btnDisabled">获取验证码<span v-show="btnDisabled" class="ml-5">({{second}}S)</span></van-button>
      </van-field>
      <van-field
      v-model="form.code"
      maxlength='6'
      type="number"
      value=""
      placeholder="请输入验证码"
      :left-icon="img.code"
      @input="changeCode"
      />
    </van-cell-group>
    <div class="text-c mt-20">
      <van-button round size="large" :disabled="!login" color="#F6AB00" @click="toLogin">登录</van-button>
      <div class="f-12 mt-10"><span class="c-gray">登录注册表示同意</span><span class="f-w c-black">
<router-link :to="{name: 'Agreement'}"> 用户协议</router-link>、<router-link :to="{name: 'Privacy'}">隐私条款</router-link></span></div>
    </div>
    <!-- <div class="bottom_box">
      <img class="pic-bottom" :src="img.wechat">
    </div> -->
  </div>
</template>
<script>
  import login from '../../../api/member/memberinfo';
  import {Field ,Icon,Button,Cell, CellGroup} from 'vant'
  export default {
    data () {
      return {
        second:60,
        btnDisabled:false,
        login:false,
        form:{
         mobile:'',
         code:'',
         source:1
       },
       img:{
        mobile: require('../../../assets/img/mobile.png'),
        code: require('../../../assets/img/code.png'),
        wechat: require('../../../assets/img/wechat.png')
      }
    }
  },
  created () {
    this.$store.commit('param/show', false)
  },
  methods: {
    getCode(){
      let mobile=this.form.mobile
      if(!(/^1[3456789]\d{9}$/.test(mobile))){
        this.$toast('请填写正确的手机号');
      }else{
        this.btnDisabled=true
        let second = 60;
        let params={mobile:mobile}
        login.getCode(params).then(res => {
          if(res.data.state == 1) {
           let code=res.data.data
         }
       })
        const timer = setInterval(() => {
          second--;
          if (second) {
            this.second=second
          } else {
            clearInterval(timer);
            this.second=60
            this.btnDisabled=false
          }
        }, 1000);
      }
    },
    changeCode(value){
      let valued=value
      if(valued.length==6){
        this.login=true
      }else{
        this.login=false
      }
    },
    toLogin(){
      let mobile=this.form.mobile
      let code=this.form.code
      if(!(/^1[3456789]\d{9}$/.test(mobile))){
        this.$toast('请填写正确的手机号');
      }else{
        login.Login(this.form).then(res => {
          if(res.data.state == 1) {
            let token=res.data.data.access_token
            this.$store.dispatch('param/setToken',token)
            this.$router.go(-1)
          }
        })
      }
    }
  },
  components: {
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Button.name]:Button,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup
  }
};
</script>
<style lang="scss">
.login{
  padding: 15px;
  a{
    color: #3A3A3A;
  }
  .ml-5{
    margin-left: 5px;
  }
  .mt-20{
    margin-top: 20%;
  }
  .mt-10{
    margin-top: 10%;
  }
  .van-cell:not(:last-child)::after {
    border-bottom: 0 solid #ebedf0;
  }
  .van-cell{
    border-bottom: 1px solid #ebedf0;
  }
  [class*=van-hairline]::after{
    border: 0 solid #ebedf0; 
  }
  .text-c .van-button--large{
    width: 90%;
    height: 40px;
    line-height: 2;
  }
  .bottom_box{
    text-align: center;;
    margin-top: 40%;
    .pic-bottom{
      width: 25px;
      height: 20px;
    }
  }
}

</style>